export enum PreparedResponseType {
  default = 'default',
  custom = 'custom',
  ending = 'ending',
  locationRequest = 'location_request',
  roadsideAssistance = 'roadside_assistance',
  /**
   * The authority's reply to a text sent to its Text-From-911 number when
   * there is no active conversation. Sent by the text_from_911 service, not
   * the browser, so it cannot contain smart phrases.
   */
  bounceback = 'bounceback',
}

/**
 * Types an authority may assign to at most one message at a time. Setting one
 * of these on a message clears it from whichever message previously held it.
 */
export type SingletonResponseType =
  | PreparedResponseType.ending
  | PreparedResponseType.locationRequest
  | PreparedResponseType.roadsideAssistance
  | PreparedResponseType.bounceback;

/**
 * Singleton types guaranteed a rapidsos system default, so a preferred message
 * can always be resolved for one. The bounce-back has no default row: with none
 * assigned, the text_from_911 service sends its built-in template.
 */
export type DefaultedSingletonResponseType = Exclude<
  SingletonResponseType,
  PreparedResponseType.bounceback
>;

export const SINGLETON_RESPONSE_TYPES: readonly PreparedResponseType[] = [
  PreparedResponseType.ending,
  PreparedResponseType.locationRequest,
  PreparedResponseType.roadsideAssistance,
  PreparedResponseType.bounceback,
];

/**
 * Human-readable name of the action each singleton type backs. Single source
 * of truth for the assigned-message slot labels and any UI that needs to name
 * the action a message is assigned to.
 */
export const SINGLETON_TYPE_ACTION_LABELS: Record<
  SingletonResponseType,
  string
> = {
  [PreparedResponseType.ending]: 'End Chat',
  [PreparedResponseType.locationRequest]: 'Location Request',
  [PreparedResponseType.roadsideAssistance]: 'Roadside Assistance',
  [PreparedResponseType.bounceback]: 'Bounce-back',
};
